/**
 * Configuration for Citybiz frontend.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'SiliconJobs',
    SITE_DESCRIPTION: 'SiliconJobs.org',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/sj/logo.png',
      faviconsPath: '/static/sj',
    },
    OG_IMAGE: '/static/sj/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#2a32f5',
        secondary: '#213c48',
      },
    },
    PRICE_CONFIG: priceConfig,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ'],
    BLOG_FEATURE_ACTIVE: true,
  },
});
